"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCommandSuccess = function (command) {
    return !exports.isCommandError(command);
};
exports.isCommandError = function (command) {
    if (!command)
        return false; // is null, undefined or ""
    return command.split('/')[0] === "error";
};
exports.isCommandError404 = function (command) {
    var parts = command.split('/');
    return parts[0] === "error" && parts[1] === "dyna-node" && parts[2] === "404";
};
//# sourceMappingURL=isCommand.js.map